import { select, Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { State } from '@app/store/state/state';
import { Hotel } from '@hotels/hotels-home/entities/hotel';
import { Destination } from '@hotels/hotels-home/entities/destination';
import { PopularPlace } from '@hotels/hotels-home/entities/popular-place';
import {
  fetchPopularDestinationsAction,
  fetchPopularHotelsAction,
  fetchPopularPlacesAction
} from '@hotels/hotels-home/store/actions/hotels.actions';
import {
  isLoadingPopularDestinations,
  isLoadingPopularHotels,
  isLoadingPopularPlaces
} from '@hotels/hotels-home/store/selectors/ui.selector';
import { selectPopularHotels } from '@hotels/hotels-home/store/selectors/popular-hotels.selector';
import { selectPopularPlaces } from '@hotels/hotels-home/store/selectors/popular-places.selector';
import { selectPopularDestinations } from '@hotels/hotels-home/store/selectors/popular-destinations.selector';

@Injectable()
export class HotelsHomeFacade {

  constructor(private store: Store<State>) { }

  public popularHotels$: Observable<Hotel[]> = this.store.pipe(select(selectPopularHotels));
  public popularPlaces$: Observable<PopularPlace[]> = this.store.pipe(select(selectPopularPlaces));
  public popularDestinations$: Observable<Destination[]> = this.store.pipe(select(selectPopularDestinations));
  public isLoadingPopularHotels$: Observable<boolean> = this.store.pipe(select(isLoadingPopularHotels));
  public isLoadingPopularPlaces$: Observable<boolean> = this.store.pipe(select(isLoadingPopularPlaces));
  public isLoadingPopularDestinations$: Observable<boolean> = this.store.pipe(select(isLoadingPopularDestinations));

  public fetchPopularDestinations(): void {
    this.store.dispatch(fetchPopularDestinationsAction());
  }

  public fetchPopularHotels(): void {
    this.store.dispatch(fetchPopularHotelsAction());
  }

  public fetchPopularPlaces(): void {
    this.store.dispatch(fetchPopularPlacesAction());
  }

}
